import { useModal } from 'context/ModalContext';
import { useRouteContext } from 'context/RouterContext';
import { PROTECTED_PATH } from 'shared/constants';
import { useLangNavigate } from 'shared/hooks';
import { getPathWithoutLang } from 'shared/lib/converter';
import { useInfoStore } from 'store/useInfoStore';

import { useScrollToTopOnNavigation } from './useScrollToTopOnNavigation';

export const useRouteChangeHandler = () => {
  const { navigateWithLang } = useLangNavigate();
  const { openModal, closeModal, MODAL_TYPES } = useModal();
  const { accessToken, firstName, lastName, email } = useInfoStore();
  const { redirectPath, setRedirectPath } = useRouteContext();

  useScrollToTopOnNavigation();

  const handleRouteChange = (path: string, replace?: boolean) => {
    const isProtectedPath = PROTECTED_PATH.some((protectedPath) => path.startsWith(protectedPath));
    const isLogin = email !== '' && firstName !== '' && lastName !== '' && accessToken !== '';

    if (isProtectedPath && !isLogin) {
      setRedirectPath(path);
      openModal(MODAL_TYPES.LOGIN);
      return;
    }

    navigateWithLang(path, { replace });
  };

  const handleLoginSuccess = () => {
    closeModal();

    // URL 파라미터에서 redirect 값 확인
    const urlParams = new URLSearchParams(window.location.search);
    const urlRedirectPath = urlParams.get('redirect');

    if (urlRedirectPath) {
      const pathWithoutLang = getPathWithoutLang(urlRedirectPath);
      navigateWithLang(pathWithoutLang);
    } else if (redirectPath) {
      // 기존 RouterContext의 redirectPath 사용
      // console.log('redirectPath', redirectPath);
      navigateWithLang(redirectPath);
      setRedirectPath(null);
    }
  };

  return { handleRouteChange, handleLoginSuccess };
};
